export default {
  nav: {
    main: 'Glavna',
    ordersAndInvoices: 'Porudzbine i fakture',
    drafts: 'Nacrti',
    automation: 'Automatizacija',
    workspace: 'Radni prostor',
    templates: 'Sabloni',
    delivery: 'Dostava',
    settings: 'Podesavanja',
    shippingLabels: 'Nalepnice za slanje',
    subscriptions: 'Pretplate',
    support: 'Podrska',
    developer: 'Razvojni programer',
    writeReview: 'Napisite recenziju',
    supportTicket: 'Zahtev za podrsku',
    welcomeTour: 'Tura dobrodoslice',
    administratorConsole: 'Administratorska konzola',
    logout: 'Odjava',
  },
  dashboard: {
    pageTitle: 'Porudzbine i fakture',
    pageDescription: 'Manage your orders and invoices',
    title: 'Porudzbine i fakture',
    selectedOrders: '{count} izabranih porudzbina',
    completed: '% zavrseno',
    processing: 'Obrada, molimo sacekajte...',
    bulkDownload: 'Grupno preuzimanje',
    upgradeBulkDownload: 'Nadogradite plan za grupno preuzimanje',
    showFilters: 'Prikazi filtere',
    hideFilters: 'Sakrij filtere',
    creatingInvoices: 'Kreiranje faktura, molimo sacekajte...',
    bulkCreateInvoices: 'Grupno kreiranje faktura',
    cannotCreateAutopilot: 'Ne mozete rucno kreirati fakture kada je rezim fakturisanja na autopilotu.',
    exportInvoices: 'Izvezi fakture ili porudzbine',
    capturePayments: 'Rucno preuzmi placanja',
    filterOrders: 'Filtriraj porudzbine',
    error: 'Hej, nesto je poslo naopako...',
    close: 'Zatvori',
    chooseDate: 'Izaberite datum',
    chooseIssueDate: 'Izaberite datum izdavanja za izabrane fakture',
    cancel: 'Otkazi',
    createInvoices: 'Kreiraj fakture',
    storno: 'Storno',
    bulkOrderCapture: 'Grupno preuzimanje porudzbina',
  },
  search: {
    createdBetween: 'Kreirano izm.',
    modifiedBetween: 'Izmenjeno izm.',
    orderNumber: 'Porudzbina #',
    invoiceNumber: 'Faktura #',
    refundNumber: 'Povracaj #',
    customer: 'Kupac',
    payment: 'Placanje',
    any: 'Bilo koji',
    authorized: 'Autorizovano',
    pending: 'Na čekanju',
    paid: 'Plaćeno',
    partiallyPaid: 'Delimično plaćeno',
    refunded: 'Vraćeno',
    voided: 'Poništeno',
    partiallyRefunded: 'Delimično vraćeno',
    unpaid: 'Neplaćeno',
    fulfillment: 'Ispunjenje',
    fulfilled: 'Isporučeno',
    partial: 'Delimično',
    unfulfilled: 'Neisporučeno',
    loading: 'Ucitavanje porudzbina...',
    search: 'Pretraga',
  },
  orderList: {
    noCustomer: 'Nema kupca',
    downloadOrder: 'Preuzmi porudzbinu',
    deleteWarning: 'Vazno! Ovo ce obrisati sve fakture i povracaje kreirane nakon datuma:',
    includingInvoice: 'ukljucujuci izabranu fakturu #',
    pressOk: 'Pritisnite OK za nastavak ili Otkazi za prekid.',
    cannotCreateAutopilot: 'Ne mozete rucno kreirati fakture kada je rezim fakturisanja na autopilotu.',
    createInvoice: 'Kreiraj fakturu za ovu porudzbinu',
    create: 'Kreiraj',
    addCreditNote: 'Dodaj knjizno odobrenje',
    createStorno: 'Kreiraj storno fakturu',
    refund: 'Povracaj',
    downloadInvoice: 'Preuzmi ovu fakturu',
    download: 'Preuzmi',
    default: 'Podrazumevano',
    downloadStorno: 'Preuzmi ovu storno/knjizno odobrenje',
    fulfillOrder: 'Ispuni porudzbinu',
    orderNum: 'Porudzbina #',
    locPrefix: 'Prefiks lokacije',
    invoiceNum: 'Faktura #',
    refundNum: 'Povracaj #',
    customerCol: 'Kupac',
    orderCreatedDate: 'Datum kreiranja porudzbine',
    orderModifiedDate: 'Datum izmene porudzbine',
    delivered: 'Isporuceno',
    paymentStatus: 'Status placanja',
    fulfillmentStatus: 'Status isporuke',
    totalOutstanding: 'Ukupan preostali iznos',
    originalPrice: 'Originalna cena',
    noOrders: 'Vasa prodavnica nema porudzbina za izabrani status.',
    cannotCreateNoOrders: 'Ne mozete kreirati fakture kada nema porudzbina.',
    createOrdersFirst: 'Molimo kreirajte bar jednu porudzbinu i pokusajte ponovo.',
    createOrders: 'Kreiraj porudzbine',
    loadingOrders: 'Ucitavanje...',
    paidManual: 'Plaćeno - Ručno',
    paid: 'Plaćeno',
    refunded: 'Vraćeno',
    pending: 'Na čekanju',
    partiallyPaid: 'Delimično plaćeno',
    partiallyRefunded: 'Delimično vraćeno',
    fulfilled: 'Isporučeno',
    unfulfilled: 'Neisporučeno',
    deliveryPending: 'Na čekanju',
    deliverNow: 'Dostavi sada',
    deliveryPartial: 'Delimična',
    notDelivered: 'Nije dostavljeno',
    deliverAgain: 'Dostavi ponovo',
    deliveryDetails: 'Detalji dostave',
    deliveryFailed: 'Dostava neuspešna',
    sent: 'Poslato',
    failed: 'Neuspelo',
    toLabel: 'Za',
    folderLabel: 'Fascikla',
    open: 'Otvoreno',
    invoice: 'Faktura',
    creditNote: 'Knjižno odobrenje',
    stornoLabel: 'Storno',
    unknown: 'Nepoznato',
    googleDrive: 'Google Drive',
    clientsTablet: 'Tablet klijenata',
    shippyPro: 'ShippyPro',
    emailChannel: 'E-pošta',
    ftpChannel: 'FTP',
    revertToDate: 'Vrati na ovaj datum',
    add: 'Dodaj',
    close: 'Zatvori',
  },
  downloadDialog: {
    downloadType: 'Preuzmi {type}...',
    selectTemplate: 'Izaberite jedan sablon iz galerije za izvoz porudzbina, faktura, storno faktura ili knjiznih odobrenja.',
    getMoreTemplates: 'Nabavite vise sablona',
    createNewTemplate: 'Kreirajte novi sablon',
    allCreatedBetween: 'Svi kreirani {type} izmedju',
    selectedType: 'Izabrani {type}',
    and: 'i',
    status: 'Status',
    any: 'Bilo koji',
    open: 'Otvoreno',
    closed: 'Zatvoreno',
    cancelled: 'Otkazano',
    paymentStatus: 'Status placanja',
    fulfillmentStatus: 'Status isporuke',
    fulfilled: 'Isporučeno',
    partial: 'Delimično',
    unfulfilled: 'Neisporučeno',
    authorized: 'Autorizovano',
    pending: 'Na čekanju',
    paid: 'Plaćeno',
    partiallyPaid: 'Delimično plaćeno',
    refunded: 'Vraćeno',
    voided: 'Poništeno',
    partiallyRefunded: 'Delimično vraćeno',
    unpaid: 'Neplaćeno',
    format: 'Format',
    forLocation: 'Za lokaciju',
    advancedOptions: 'Napredne opcije',
    exportHSCodes: 'Izvezi HS kodove inventara (sporije)',
    noteChrome: 'Napomena: Za optimalno preuzimanje preporučuje se Chrome i isključivanje blokera reklama.',
    downloadIndividually: 'Preuzmi pojedinačno',
    downloadGrouped: 'Preuzmi grupisano',
  },
  templates: {
    pageTitle: 'Sabloni',
    pageDescription: 'Customize your invoice templates',
    title: 'Sabloni',
    installTranslated: 'Instalirajte prevedeni sablon',
    installTranslatedDesc: 'Izaberite drugi jezik klikom na ovo dugme.',
    createNew: 'Kreirajte novi sablon ako je potrebno',
    createNewDesc: 'Kliknite na ovo dugme da kreirate novi sablon ako je potrebno.',
    customize: 'Prilagodite sablone',
    customizeDesc: 'Kliknite na podrazumevani sablon da ga prilagodite. Mozete promeniti logo, boje i za naprednije korisnike, kod iza njega.',
    defaultTemplate: 'Faktura, storno i knjizno odobrenje (Podrazumevano)',
    logo: 'Logo',
    colorPalette: 'Paleta boja',
    getColorPalettes: 'Nabavite palete boja',
    paperSize: 'Velicina papira',
    format: 'Format',
    a3: 'A3 (297 x 420 mm)',
    a4: 'A4 (210 x 297 mm)',
    a5: 'A5 (148 x 210 mm)',
    legal: 'Legal (215.9 x 355.6 mm)',
    letter: 'Letter (215.9 x 279.4 mm)',
    tabloid: 'Tabloid (279.4 x 431.8 mm)',
    mcPrint3: 'mC-Print3 Roll (80 x 155 mm)',
    mcPrint2: 'mC-Print2 Roll (57.5 x 155 mm)',
    orientation: 'Orijentacija',
    landscape: 'Polozeno',
    portrait: 'Uspravno',
    margin: 'Margina (cm)',
    unsavedChanges: 'Nesacuvane izmene',
    discard: 'Odbaci',
    save: 'Sacuvaj',
  },
  labels: {
    pageTitle: 'Nalepnice za slanje',
    pageDescription: 'Create and manage shipping labels',
    title: 'Nalepnice za slanje',
    glsRequiresPro: 'GLS nalepnice za slanje za EEU zahtevaju Professional plan.',
    upgradeDesc: 'Nadogradite na Professional da kreirate i upravljate nalepnicama za slanje.',
    upgradePlan: 'Nadogradite plan',
    eeuGls: 'EEU GLS',
    enabled: 'Omoguceno',
    country: 'Drzava',
    hungary: 'Madjarska',
    slovakia: 'Slovacka',
    czech: 'Ceska',
    romania: 'Rumunija',
    slovenia: 'Slovenija',
    croatia: 'Hrvatska',
    senderId: 'ID posiljaoca',
    username: 'Korisnicko ime',
    password: 'Lozinka',
    name: 'Ime',
    city: 'Grad',
    address: 'Adresa',
    zipCode: 'Postanski broj',
    contactPerson: 'Kontakt osoba',
    phone: 'Telefon',
    email: 'Email',
    glsServices: 'GLS usluge',
    expressService: 'Ekspresna usluga',
    exchangeService: 'Usluga razmene',
    smsService: 'SMS usluga',
    smsText: 'SMS tekst',
    preAdviceService: 'Usluga prethodnog obavestenja',
    unsavedChanges: 'Nesacuvane izmene',
    discard: 'Odbaci',
    save: 'Sacuvaj',
  },
  billing: {
    pageTitle: 'Naplata',
    pageDescription: 'Manage your subscription and billing',
    title: 'Naplata',
    subscriptionFor: 'Plan pretplate za prodavnicu',
    currentlySubscribed: 'Trenutno ste pretplaceni na',
    plan: 'plan',
    cancelSubscription: 'Otkazite pretplatu',
    upgradePlan: 'Nadogradite plan',
    professional: 'Professional',
    proPriceMonthly: '$29.99 / mesecno',
    upgrade: 'Nadogradi',
    includesAllStarter: 'Ukljucuje sve Starter funkcije, plus:',
    proFeature1: 'Globalna uskladjenost: Prefiksi zasnovani na lokaciji i prilagodjeno sekvencijalno numerisanje',
    proFeature2: 'Pametna lokalizacija: Automatski prevedeni emailovi i lokalizovani PDF prilozi',
    proFeature3: 'Kompletan B2B ciklus dokumenata: Profakture, B2B ponude i knjizna odobrenja',
    proFeature4: 'B2B sinhronizacija racunovodstva: Preciznost od 3 decimale i prikaz vise valuta',
    proFeature5: 'Automatske rezervne kopije: Automatsko kopiranje faktura na siguran FTP ili Google Drive',
    proFeature6: 'Shopify Flow: Automatizujte generisanje, dostavu i storno faktura putem Flow okidaca i akcija',
    proFeature7: 'Napredna AI logika: Koristite AI na uredjaju za slozene uslovne klauzule rasporeda',
    proFeature8: 'UBL XML i ZUGFeRD / Factur-X izvoz (Evropska uskladjenost sa e-fakturisanjem)',
    proFeature9: 'EPC QR kodovi za trenutna mobilna POS placanja',
    proFeature10: 'GLS nalepnice za slanje za EEU',
    proFeature11: '7 godina cuvanja u skladu sa poreskim propisima',
    currentlyUsing: 'Trenutno koristite nas',
    free: 'besplatni',
    subscriptionPlan: 'plan pretplate.',
    monthlyUsage: 'Mesecna potrosnja',
    monthlyGenerated: '{count} / 50 faktura ovog meseca',
    monthlyLimitReached: 'Mesecni limit je dostignut. Nadogradite na Starter za neogranicene fakture.',
    freePlan: 'Besplatni plan',
    freeToInstall: 'Besplatna instalacija',
    freeFeature1: 'Do 50 faktura/porudzbina mesecno',
    freeFeature2: 'Pristup svim 31+ predefinisanim sablonima',
    freeFeature3: 'Osnovni AI Copilot',
    freeFeature4: 'Standardno preuzimanje i stampanje PDF-a',
    freeFeature5: 'Standardni paket dokumenata (Fakture, otpremnice, racuni)',
    freeFeature6: '3 meseca sigurnog cuvanja faktura',
    starterPlan: 'Starter plan',
    starterPrice: '$9.99 / mesecno',
    starterPricePerInvoice: '+ 3c po kreiranoj fakturi',
    subscribe: 'Pretplatite se',
    starterFeature1: 'Neogranicene fakture i porudzbine',
    starterFeature2: 'Automatska dostava PDF-a putem emaila',
    starterFeature3: 'Pun pristup hibridnom editoru i AI Copilotu',
    starterFeature4: 'Shopify POS i integracija barkodova',
    starterFeature5: 'Shopify Flow: Okidaci i akcije za automatizaciju faktura',
    starterFeature6: 'UBL XML / PEPPOL i ZUGFeRD / Factur-X izvoz (Uskladjenost sa e-fakturisanjem)',
    starterFeature7: '1 godina sigurnog cuvanja faktura',
    proTaxOverrides: 'Prilagodjena poreska pravila: PDV / GST po proizvodu i stope na nivou SKU',
    unsavedChanges: 'Nesacuvane izmene',
    discard: 'Odbaci',
    save: 'Sacuvaj',
  },
  autopilot: {
    pageTitle: 'Automatizacija',
    pageDescription: 'Automate invoice creation and management',
    title: 'Automatizacija',
    autoCreate: 'Automatski kreiraj fakture',
    disabled: 'Onemoguceno (Rucno)',
    whenCreated: 'Kada su porudzbine kreirane',
    whenFulfilled: 'Kada su porudzbine ispunjene',
    whenPaid: 'Kada su porudzbine placene',
    autoCreateDesc: 'Fakture ce biti kreirane na datum kada su porudzbine kreirane, ispunjene ili placene.',
    autoStorno: 'Automatski storniraj fakture',
    whenCancelled: 'Kada su porudzbine otkazane ili refundirane',
    autoStornoDesc: 'Storno fakture ce biti kreirane na datum kada su porudzbine ponistene/otkazane ili kada su povracaji kreirani.',
    cannotAutoFree: 'Automatsko kreiranje faktura nije moguce sa besplatnim planom.',
    upgradePlan: 'Nadogradite plan',
    unsavedChanges: 'Nesacuvane izmene',
    discard: 'Odbaci',
    save: 'Sacuvaj',
  },
  delivery: {
    pageTitle: 'Dostava',
    pageDescription: 'Configure invoice delivery via email, FTP, or Google Drive',
    title: 'Dostava',
    settings: 'Podesavanja',
    useOrderNumbers: 'Koristi brojeve porudzbina za fajlove',
    sendIfCountry: 'Posalji ako je drzava adrese za naplatu',
    countryCodesHint: 'Navedite sve kodove drzava razdvojene tackom i zarezom.',
    sendForTags: 'Posalji za kupce koji imaju jednu od navedenih oznaka',
    tagsHint: 'Navedite sve oznake razdvojene tackom i zarezom.',
    emailDelivery: 'Dostava emailom',
    sendAsPdf: 'Posalji fakture kao PDF priloge kupcima',
    autoSend: 'Automatski posalji kada je faktura kreirana',
    subject: 'Predmet',
    body: 'Telo poruke',
    xmlAttachments: 'XML prilozi',
    attachUbl: 'Prilozi UBL/PEPPOL XML (E-Factura)',
    attachZugferd: 'Prilozi ZUGFeRD / Factur-X XML',
    sendTestEmail: 'Posalji test email',
    sending: 'Slanje...',
    customSmtp: 'Prilagodjeni SMTP server',
    customSmtpDesc: 'Koristite sopstveni mail server umesto podrazumevanog',
    enableSmtp: 'Omoguci prilagodjeni SMTP',
    smtpHost: 'SMTP host',
    port: 'Port',
    useSsl: 'Koristi SSL/TLS',
    username: 'Korisnicko ime',
    password: 'Lozinka',
    fromEmail: 'Email posiljaoca',
    fromName: 'Ime posiljaoca',
    shopifyLiquid: 'Shopify Liquid sablon',
    pasteInto: 'Nalepite ovo u vas',
    orderConfirmation: 'sablon potvrde porudzbine',
    toAddLink: 'da dodate link za preuzimanje.',
    downloadInvoice: 'Preuzmite vasu fakturu',
    clientsTablet: 'ClientsTablet',
    clientsTabletDesc: 'Posalji zahteve ka ClientsTablet kada su fakture kreirane',
    shippyPro: 'ShippyPro',
    shippyProDesc: 'Posalji PDF fakture kao carinske dokumente na ShippyPro za zemlje van EU',
    ftpBackup: 'FTP / SFTP rezervna kopija',
    ftpDesc: 'Automatski kopiraj fakture na vas server',
    enableFtp: 'Omoguci automatsku FTP rezervnu kopiju',
    host: 'Host',
    useSftp: 'Koristi SFTP (sigurno)',
    destinationFolder: 'Odredisni folder',
    xmlFiles: 'XML fajlovi',
    includeUbl: 'Ukljuci UBL/PEPPOL XML (E-Factura)',
    includeZugferd: 'Ukljuci ZUGFeRD / Factur-X XML',
    testConnection: 'Testiraj konekciju',
    testing: 'Testiranje...',
    pro: 'PRO',
    upgradeFtp: 'Nadogradite na Professional da automatski kopirate fakture na vas FTP/SFTP server.',
    googleDrive: 'Google Drive',
    googleDriveDesc: 'Automatski sinhronizujte fakture na vas Drive',
    connected: 'Povezano',
    disconnect: 'Prekini vezu',
    notWorking: 'Ne radi? Idite na',
    googlePermissions: 'Google dozvole',
    removeThenReconnect: 'uklonite Invoice Browse, zatim ponovo povezite.',
    connectGoogleDrive: 'Povezi Google Drive',
    upgradeGoogleDrive: 'Nadogradite na Professional da automatski sinhronizujete fakture na Google Drive.',
    unsavedChanges: 'Nesacuvane izmene',
    discard: 'Odbaci',
    freePlanTitle: 'Automated delivery is not available on the free plan',
    freePlanDesc: 'Upgrade to Starter or Professional to automatically send invoices via email, FTP, or Google Drive.',
    emailLiquidTemplate: 'Email Liquid Template',
    liquidTemplateDesc: 'Copy and paste this code to your order confirmation template. Click {link} to open it.',
    here: 'here',
    save: 'Sacuvaj',
  },
  bookkeeping: {
    pageTitle: 'Podesavanja',
    pageDescription: 'Configure your invoice settings',
    title: 'Podesavanja',
    owner: 'Vlasnik',
    email: 'Email',
    phone: 'Telefon',
    keepDifferentNumbering: 'Zadrzi razlicitu numeraciju faktura za svaku lokaciju porudzbine',
    keepDifferentNumberingDisabled: 'Zadrzavanje razlicite numeracije faktura za svaku lokaciju porudzbine nije opcija omogucena sa vasim planom.',
    locationEmailDesc: 'Ovo vam omogucava da saljete emailove i fakture prevedene na osnovu lokacije porudzbine: lokacija inventara, adresa za dostavu ili naplatu',
    upgradePlan: 'Nadogradite plan',
    matchingCriteria: 'Kriterijumi podudaranja',
    locationId: 'ID lokacije',
    shippingCountryCode: 'Kod drzave adrese za dostavu',
    billingCountryCode: 'Kod drzave adrese za naplatu',
    matchLocationDesc: 'Podudarite lokaciju na osnovu ID-a lokacije porudzbine, koda drzave adrese za dostavu ili naplatu.',
    companyInfo: 'Informacije o kompaniji',
    name: 'Naziv',
    website: 'Veb sajt',
    registrationNumber: 'Maticni broj',
    taxId: 'PIB',
    addressSection: 'Adresa',
    streetName: 'Naziv ulice',
    streetNumber: 'Broj',
    zip: 'Postanski broj',
    city: 'Grad',
    region: 'Region',
    country: 'Drzava',
    bankingInfo: 'Bankovne informacije',
    bankName: 'Naziv banke',
    swift: 'Swift',
    currency: 'Valuta',
    iban: 'IBAN',
    invoicing: 'Fakturisanje',
    decimalPlaces: 'Decimalna mesta',
    invoicesPrefix: 'Prefiks faktura',
    currentInvoiceNumber: 'Trenutni broj fakture',
    creditNotesPrefix: 'Prefiks knjiznih odobrenja',
    currentCreditNoteNumber: 'Trenutni broj knjiznog odobrenja',
    lastInvoiceDate: 'Datum poslednje fakture',
    noInvoicesYet: 'Jos uvek nema kreiranih faktura.',
    confirmReverting: 'Potvrdite vracanje sistema',
    allInvoicesAfter: 'Sve fakture i njihovi storno izdati nakon',
    willBeRemoved: 'bice uklonjeni. Nastaviti sa vracanjem sistema?',
    cancel: 'Otkazi',
    revert: 'Vrati',
    revertDesc: 'Vracanje sistema ce obrisati sve fakture kreirane nakon izabranog datuma.',
    revertToDate: 'Vrati na ovaj datum',
    reverting: 'Vracanje sistema, molimo sacekajte...',
    useOrderNumbering: 'Koristi numeraciju porudzbina',
    showVat: 'Prikazi PDV na fakturama',
    overrideTaxes: 'Pregazi poreze',
    pricesIncludeTax: 'Cene ukljucuju porez',
    productsTaxRate: 'Poreska stopa za proizvode',
    shippingTaxRate: 'Poreska stopa za dostavu',
    skusSeparated: 'SKU-ovi razdvojeni tackom i zarezom',
    skusTaxRate: 'Poreska stopa za SKU-ove',
    useOrderDates: 'Koristi datume kreiranja porudzbina za fakture',
    convertCurrency: 'Konvertuj cene u valutu u kojoj kupac placa',
    unsavedChanges: 'Nesacuvane izmene',
    discard: 'Odbaci',
    save: 'Sacuvaj',
  },
  drafts: {
    pageTitle: 'Nacrti',
    pageDescription: 'Manage your draft orders',
    title: 'Nacrti',
    download: 'Preuzmi',
    newDraft: 'Novi nacrt',
    exporting: 'Izvoz {status}%...',
    accessNotGranted: 'Pristup nacrtima porudzbina nije odobren. Molimo',
    reLogin: 'prijavite se ponovo',
    toGrantPermissions: 'da biste odobrili potrebne dozvole za "Nacrte porudzbina".',
    pushFailed: 'Slanje na Shopify nije uspelo:',
    exportError: 'Greska pri izvozu:',
    confirmDelete: 'Da li ste sigurni da zelite da obrisete ovaj nacrt?',
    incompleteCustomer: 'Podaci o kupcu su nepotpuni:',
    pushWithoutCustomer: 'Nacrt ce biti poslat na Shopify bez podataka o kupcu. Nastaviti?',
    customerNotInShopify: 'Ovaj kupac jos ne postoji u Shopify-ju.',
    warnings: 'Upozorenja:',
    createCustomerAndPush: 'Kreirati kupca u Shopify-ju i poslati nacrt porudzbine?',
    downloadTitle: 'Preuzmi nacrte',
    cancel: 'Otkaži',
  },
  draftEdit: {
    number: "Broj",
    prefix: "Prefiks",

    newDraft: 'Novi nacrt',
    editDraft: 'Izmeni nacrt',
    viewInShopify: 'Pogledaj u Shopify-ju',
    back: 'Nazad',
    createDraft: 'Kreiraj nacrt',
    saveChanges: 'Sacuvaj izmene',
    documentType: 'Tip dokumenta',
    draftOrder: 'Nacrt porudzbine',
    quote: 'Ponuda',
    proforma: 'Profaktura',
    manualInvoice: 'Rucna faktura',
    currency: 'Valuta',
    expiryDate: 'Datum isteka',
    status: 'Status',
    draft: 'Nacrt',
    sent: 'Poslato',
    accepted: 'Prihvaceno',
    customer: 'Kupac',
    firstName: 'Ime',
    lastName: 'Prezime',
    email: 'Email',
    phone: 'Telefon',
    company: 'Kompanija',
    taxId: 'PIB',
    billingAddress: 'Adresa za naplatu',
    address: 'Adresa',
    aptSuite: 'Stan/Apartman',
    city: 'Grad',
    province: 'Pokrajina',
    countryField: 'Drzava',
    zip: 'Postanski broj',
    shippingAddress: 'Adresa za dostavu',
    sameAsBilling: 'Isto kao adresa za naplatu',
    lineItems: 'Stavke',
    shipping: 'Dostava',
    shippingTitle: 'Naziv',
    shippingPlaceholder: 'npr. Standardna dostava',
    price: 'Cena',
    note: 'Napomena',
    notePlaceholder: 'Interna napomena ili poruka kupcu...',
    summary: 'Rezime',
    subtotal: 'Medjuzbir',
    discounts: 'Popusti',
    tax: 'Porez',
    total: 'Ukupno',
  },
  login: {
    pageTitle: 'Invoice Browse - Monthly batch invoicing',
    enterShopAddress: 'Unesite adresu vase prodavnice',
    loginWith: 'Prijavite se sa',
    createAccount: 'Kreirajte novi nalog',
    placeholder: 'naziv-vase-prodavnice',
    shopRequired: 'Naziv prodavnice je obavezan',
    login: 'Prijava',
    shopify: 'Shopify',
    terms: 'Uslovi koriscenja',
    privacy: 'Politika privatnosti',
  },
  developer: {
    pageTitle: 'Developer Tools',
    pageDescription: 'Developer tools and API configuration',
  },
  leads: {
    pageTitle: 'Leads',
    pageDescription: 'Manage your leads',
  },
  review: {
    enjoying: 'Uzivate u Invoice Browse?',
    description: "Kreirali ste svoje prve fakture! Ako vam je aplikacija korisna, kratka recenzija na Shopify App Store nam mnogo znaci.",
    reward: "Kao zahvalnost, resetovacemo vas mesecni brojac potrosnje na 0",
    leaveReview: 'Ostavite recenziju',
    maybeLater: 'Mozda kasnije',
  },
  footer: {
    copyright: '© 2026 Growth Connections',
  },
  joyride: {
    welcomeTitle: 'Dobrodosli u Invoice Browse',
    welcomeContent: 'Dozvolite da vam pokazem kako mozete da ga koristite.',
    dashboardTitle: 'Kontrolna tabla',
    dashboardContent: 'Ekran koji vidite je glavna kontrolna tabla. Ovde mozete pronaci sve porudzbine i mozete ih izvesti u razlicite tipove dokumenata kao sto su: fakture, otpremnice i drugi.',
    automationTitle: 'Olaksajte sebi zivot',
    automationContent: 'Omogucite automatizaciju da kreirate fakture kad god su porudzbine placene ili refundirane.',
    templatesTitle: 'Prilagodite sablone',
    templatesContent: 'Udjite ovde da prevedete svoj sablon, prilagodite ga ili kreirate novi.',
    deliveryTitle: 'Dostava',
    deliveryContent: 'Konfiguriste nasu aplikaciju da automatski kopira kreirana dokumenta na FTP, Google Drive, ili kao priloge za emailove.',
    settingsTitle: 'Podesavanja',
    settingsContent1: 'Podesite broj telefona kompanije, email i druga polja koja se koriste na dokumentima.',
    settingsContent2: 'Promenite pocetni broj dokumenta ili obrisite dokumenta kreirana nakon odredjenog datuma.',
    settingsContent3: 'Pregazite PDV stope za dostavu i proizvode',
    settingsContent4: 'Promenite broj decimalnih mesta za brojeve',
    reviewTitle: 'Napisite recenziju',
    reviewContent: 'Podrzite nas tim tako sto cete nam napisati dobru recenziju!',
    tourTitle: 'Tura dobrodoslice',
    tourContent: 'Hej, mozete ponovo otvoriti ovu turu odavde.',
    createDocTitle: 'Kreirajte svoj prvi dokument',
    createDocContent: 'Kliknite na dugme Kreiraj da kreirate svoj prvi dokument.',
    docNumberTitle: 'Broj dokumenta',
    docNumberContent: 'Prvom dokumentu je dodeljen broj 1. Ako zelite da pocnete sa drugim brojem, mozete to promeniti u Podesavanjima.',
    downloadDocTitle: 'Preuzmite dokument',
    downloadDocContent: 'Kliknite na padajuci meni Preuzmi i izaberite sablon dokumenta da izvezete svoju porudzbinu kao PDF.',
  },
  common: {
    save: 'Sacuvaj',
    cancel: 'Otkazi',
    close: 'Zatvori',
    discard: 'Odbaci',
    delete: 'Obrisi',
    edit: 'Izmeni',
    create: 'Kreiraj',
    loading: 'Ucitavanje...',
    unsavedChanges: 'Nesacuvane izmene',
    upgradePlan: 'Nadogradite plan',
  },
  languageSelector: {
    label: 'Jezik',
    auto: 'Automatsko prepoznavanje',
  },
  draftList: {
    draftNum: 'Nacrt #',
    shopifyId: 'Shopify ID',
    type: 'Tip',
    customer: 'Kupac',
    total: 'Ukupno',
    status: 'Status',
    delivered: 'Isporučeno',
    date: 'Datum',
    actions: 'Radnje',
    noCustomer: 'Nema kupca',
    noDrafts: 'Nema pronađenih nacrta ili ponuda.',
    loading: 'Učitavanje...',
    download: 'Preuzmi',
    default: 'Podrazumevano',
    pending: 'Na čekanju',
    deliverNow: 'Isporuči sada',
    deliveryDetails: 'Detalji isporuke',
    sent: 'Poslato',
    failed: 'Neuspelo',
    deliverAgain: 'Isporuči ponovo',
    partial: 'Delimično',
    notDelivered: 'Nije isporučeno',
    deliveryFailed: 'Isporuka neuspela',
    unknown: 'Nepoznato',
    edit: 'Izmeni',
    send: 'Pošalji',
    pushToShopify: 'Pošalji na Shopify',
    complete: 'Završi',
    duplicate: 'Dupliraj',
    delete: 'Obriši',
    quote: 'Ponuda',
    proforma: 'Proforma',
    draftOrder: 'Nacrt narudžbine',
    manualInvoice: 'Ručna faktura',
  },
  draftSearch: {
    createdBtw: 'Kreirano izm.',
    draftNum: 'Draft #',
    shopifyId: 'Shopify ID',
    customer: 'Kupac',
    status: 'Status',
    type: 'Tip',
    delivery: 'Isporuka',
    any: 'Sve',
    draft: 'Nacrt',
    sent: 'Poslato',
    accepted: 'Prihvaćeno',
    expired: 'Isteklo',
    converted: 'Konvertovano',
    cancelled: 'Otkazano',
    quote: 'Ponuda',
    proforma: 'Proforma',
    draftOrder: 'Nacrt narudžbine',
    manualInvoice: 'Ručna faktura',
    delivered: 'Isporučeno',
    notDelivered: 'Nije isporučeno',
    pending: 'Na čekanju',
    search: 'Pretraga',
  },
  draftDownload: {
    title: 'Preuzmi Nacrt #...',
    selectTemplate: 'Select a template from the gallery to export drafts, quotes, or proformas.',
    allDraftsBetween: 'All drafts between',
    selectedDrafts: 'Selected drafts',
    and: 'and',
    status: 'Status',
    documentType: 'Tip',
    any: 'Sve',
    draft: 'Nacrt',
    sent: 'Poslato',
    accepted: 'Prihvaćeno',
    expired: 'Isteklo',
    converted: 'Konvertovano',
    cancelled: 'Otkazano',
    quote: 'Ponuda',
    proforma: 'Proforma',
    draftOrder: 'Nacrt narudžbine',
    manualInvoice: 'Ručna faktura',
    format: 'Format',
    noTemplates: 'No templates found',
    noTemplatesForType: 'No templates found for document type "{type}".',
    installTemplates: 'Install templates',
    toStartExporting: 'to start exporting.',
    noteChrome: 'Note: For optimal download Chrome browser is recommended and any Adblocker to be disabled.',
    cancel: 'Cancel',
    downloadIndividually: 'Download Individually',
    downloadGrouped: 'Download Grouped',
  },
  templateEditor: {
    pageTitle: 'Template Editor',
    pageDescription: 'Edit and customize your invoice template',
    installNewTemplate: 'Instaliraj novi šablon',
    tabStyle: 'Stil',
    tabContent: 'Sadržaj',
    tabTranslations: 'Prevodi',
    tabSettings: 'Podešavanja',
    tabCode: 'Kod',
    tabCopilot: 'AI Kopilot',
    logo: 'Logo',
    colorPalette: 'Paleta boja',
    colorText: 'Text',
    colorBg: 'BG',
    colorBorder: 'Border',
    colorPrimary: 'Primary',
    colorAccent: 'Accent',
    font: 'Font',
    fontDefault: 'Default (DM Sans)',
    fontSize: 'Font Size',
    fontSizeDefault: 'Default (11.5px)',
    fontSizeCompact: 'Compact',
    fontSizeSmall: 'Small',
    fontSizeMediumSmall: 'Medium Small',
    fontSizeMedium: 'Medium',
    fontSizeMediumLarge: 'Medium Large',
    fontSizeLarge: 'Large',
    fontSizeExtraLarge: 'Extra Large',
    documentTitle: 'Document Title',
    documentTitlePlaceholder: 'e.g. Invoice, Tax Invoice, Factura...',
    noToggleSupport: 'This template does not support toggle controls. Switch to a gallery template for full customization.',
    sections: 'Sections',
    shippingAddress: 'Shipping address',
    bankPaymentDetails: 'Bank / payment details',
    paymentStatusBadge: 'Payment status badge',
    orderNotes: 'Order notes',
    trackingFulfillment: 'Tracking / fulfillment info',
    termsConditions: 'Terms & conditions',
    signatureLines: 'Signature lines',
    qrCode: 'QR code',
    lineItems: 'Line Items',
    taxColumns: 'Tax columns (VAT / GST)',
    productSku: 'Product SKU',
    productImages: 'Product images',
    discountBreakdown: 'Discount breakdown',
    itemWeight: 'Item weight',
    hsCode: 'HS code (customs)',
    mergeDiscounts: 'Merge discounts into product price',
    showOrderDiscountAsSummary: 'Show order discount as a summary line',
    totals: 'Totals',
    subtotalBeforeTax: 'Subtotal (before tax)',
    taxBreakdownByRate: 'Tax breakdown by rate',
    shippingCostSeparate: 'Shipping cost as separate line',
    dueDate: 'Due date',
    formatting: 'Formatting',
    dateFormat: 'Date format',
    decimalPlaces: 'Decimal places',
    paymentTerms: 'Payment terms',
    paymentTermsNone: 'None',
    thankYouMessage: 'Thank you message',
    thankYouPlaceholder: 'Thank you for your business!',
    countryMatchTitle: 'Use this template when shipping or billing address matches this country',
    addressType: 'Address Type',
    addressDisabled: 'Disabled',
    addressShipping: 'Shipping Address',
    addressBilling: 'Billing Address',
    country: 'Country',
    anyCountry: 'Any country',
    countryMatchDesc: 'When enabled, this template will be used automatically for orders where the selected address matches the chosen country.',
    languagePreset: 'Language Preset',
    selectLanguage: 'Select a language...',
    languagePresetDesc: 'Selecting a language fills in all labels below. You can then customize individual fields.',
    paperSize: 'Paper Size',
    format: 'Format',
    orientation: 'Orientation',
    portrait: 'Portrait',
    landscape: 'Landscape',
    margin: 'Margin (cm)',
    template: 'Template',
    templateName: 'Name',
    systemAlias: 'System Alias',
    systemAliasDesc: 'for POS/Admin URL routes',
    systemAliasNone: 'None',
    defaultTemplate: 'Default template',
    defaultTemplateDesc: 'Used for direct links shared with customers.',
    posRouteDesc: 'Maps to /template/[alias]/receipt.pdf for POS integration.',
    documentType: 'Document Type',
    invoiceCreditNote: 'Invoice + Credit Note',
    order: 'Order',
    invoiceOnly: 'Invoice only',
    quoteEstimate: 'Quote / Estimate',
    proformaInvoice: 'Proforma Invoice',
    refund: 'Refund',
    stornoInvoice: 'Storno Invoice',
    creditNoteOnly: 'Credit Note only',
    reportLiquid: 'Report (Liquid only)',
    hideRemovedItems: 'Hide removed/refunded line items',
    location: 'Location',
    locationEmpty: 'Leave empty to use for all locations',
    dangerZone: 'Danger Zone',
    dangerZoneDesc: 'Permanently remove this template from your account.',
    removeTemplate: 'Remove template',
    bodyTemplate: 'Body Template',
    bodyTemplateDesc: 'Uses Mustache or Liquid syntax. Click a snippet:',
    rowTemplate: 'Row Template',
    rowTemplateDesc: 'Rendered once per line item. Click a snippet:',
    variableReference: 'Variable Reference',
    formatCode: 'Format Code',
    insert: 'Insert',
    copy: 'Copy',
    loadModelContinue: 'Load Model & Continue',
    cancel: 'Cancel',
    copilotPlaceholder: 'Try: translate to Romanian, show tax columns, add barcode, use teal palette...',
    trySamplePrompts: 'Try these sample prompts:',
    undo: 'Undo',
    redo: 'Redo',
    aiThinking: 'AI is thinking...',
    proposedChanges: 'Proposed Changes',
    applyChanges: 'Apply Changes',
    dismiss: 'Dismiss',
    aiEngineReady: 'AI Engine ready',
    loadingAiModel: 'Loading AI model...',
    aiEngineOff: 'AI Engine off —',
    loadForAdvanced: 'load for advanced edits',
    instantCommands: 'translate, show/hide sections, add snippets, change font/colors/paper',
    aiEngineDesc: 'structural HTML edits, layout changes, custom modifications',
    aiLocalDesc: 'Model runs locally via WebGPU — no data leaves your browser. Larger models are more accurate but use more VRAM.',
    aiUpgradeDesc: 'upgrade to Starter or Professional to unlock advanced AI template editing.',
    upgrade: 'Upgrade',
    loadAiQuestion: 'Load AI Engine?',
    loadAiDesc: 'The on-device AI model will download and run locally using WebGPU. This requires ~1-3 GB of free VRAM/RAM and a modern GPU (M1+ Mac, or discrete GPU on Windows/Linux).',
  },
};



// WEBPACK FOOTER //
// app/intl/locales/sr.js